import { Login, LoginForm, PasswordInput, TextInput } from 'react-admin';
import { useSearchParams } from 'react-router';
import { required, useTranslate } from 'ra-core';
import { useEffect } from 'react';


export const MyLoginPage = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const email = searchParams.get('email') || '';
    const password = searchParams.get('password') || '';

    useEffect(() => {
        if (email) {
            searchParams.delete('email');
        }
        if (password) {
            searchParams.delete('password');
        }
        setSearchParams(searchParams);
    }, [email, password, searchParams, setSearchParams]);

    const translate = useTranslate();
    return (
        <Login>
            <LoginForm>
                <TextInput
                    autoFocus
                    source="email"
                    label={translate('ra.auth.email')}
                    autoComplete="email"
                    type="email"
                    validate={required()}
                    defaultValue={email}
                />
                <PasswordInput
                    source="password"
                    label={translate('ra.auth.password')}
                    autoComplete="current-password"
                    validate={required()}
                    defaultValue={password}
                />
            </LoginForm>
        </Login>
    );
}